module.exports = __webpack_public_path__ + "static/media/DSC08915_180531_5.d493d98c.jpg";